/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

import DefaultLogo from '../../resources/images/invoiceninja-logo@light.png';
import SmallLogo from '/logo180.png?url';

export default {
  logo: DefaultLogo,
  smallLogo: SmallLogo,
};
